<dx-popup
  [(visible)]="visible"
  [width]="700"
  [height]="480"
  [showCloseButton]="true"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [title]="getTitle()">

  <dxi-popup-toolbar-item
    [options]="{ stylingMode: 'outlined', text: ('Abbrechen' | translate), type:'normal', icon:'close', onClick: onCancel }"
    location="after"
    toolbar="bottom"
    widget="dxButton"/>
  <dxi-popup-toolbar-item
    [options]="{ stylingMode: 'outlined', text: ('Speichern' | translate), type:'default', icon:'save', onClick: onSave }"
    location="after"
    toolbar="bottom"
    widget="dxButton"/>
  <dxi-popup-toolbar-item [options]="{
                            stylingMode: 'outlined',
                            icon : fullScreen ? 'collapse' : 'fullscreen',
                            hint: fullScreen ? 'Minimize' : 'Maximize',
                            onClick: toggleFullScreen
                          }"
                          location="after"
                          toolbar="top"
                          widget="dxButton">
  </dxi-popup-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <div class="inspect-content p-2">

      <div *ngIf="error" class="text-danger mb-2">
        {{ error }}
      </div>

      <dx-tab-panel
        [animationEnabled]="true"
        [swipeEnabled]="false"
        iconPosition="start"
        stylingMode="primary"
        width="100%">

        <dxi-item [title]="'Katalog' | translate">
          <div *dxTemplate>
            <div class="p-2">
              <div class="context-row">
                <div class="context-label">{{ 'Name' | translate }}</div>
                <div class="context-value">
                  <dx-text-box [(value)]="catalog.catalogName"></dx-text-box>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Version' | translate }}</div>
                <div class="context-value">
                  <dx-text-box [(value)]="catalog.catalogVersion"></dx-text-box>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Gruppierung' | translate }}</div>
                <div class="context-value">
                  <dx-text-box [(value)]="catalog.pimGroup"></dx-text-box>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Katalog-ID' | translate }}</div>
                <div class="context-value">
                  <dx-text-box [(value)]="catalog.catalogId"></dx-text-box>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Katalogstatus' | translate }}</div>
                <div class="context-value">
                  <dx-text-box
                    [(value)]="statusCsv"
                    placeholder="Status1, Status2">
                  </dx-text-box>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Währungen' | translate }}</div>
                <div class="context-value">
                  <dx-text-box [(value)]="catalog.currency"></dx-text-box>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Länder' | translate }}</div>
                <div class="context-value">
                  <dx-text-box
                    [(value)]="territoriesCsv"
                    placeholder="DE, AT, CH">
                  </dx-text-box>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Sprache' | translate }}</div>
                <div class="context-value">
                  <dx-text-box [(value)]="catalog.language"></dx-text-box>
                </div>
              </div>
            </div>
          </div>
        </dxi-item>

        <dxi-item [title]="'Rahmenvertrag' | translate">
          <div *dxTemplate>
            <div class="p-2">
              <div class="context-row">
                <div class="context-label">{{ 'Vertrags ID' | translate }}</div>
                <div class="context-value">
                  <dx-text-box [(value)]="catalog.agreement.agreementId"></dx-text-box>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Vertragstyp' | translate }}</div>
                <div class="context-value">
                  <dx-text-box [(value)]="catalog.agreement.type"></dx-text-box>
                </div>
              </div>

              <div class="context-row context-top">
                <div class="context-label">{{ 'Beschreibung' | translate }}</div>
                <div class="context-value">
                  <dx-text-area
                    [(value)]="catalog.agreement.agreementDesc"
                    [minHeight]="80">
                  </dx-text-area>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Startzeit' | translate }}</div>
                <div class="context-value">
                  <dx-date-box
                    [(value)]="catalog.agreement.startDate"
                    type="date"
                    displayFormat="dd.MM.yyyy">
                  </dx-date-box>
                </div>
              </div>

              <div class="context-row">
                <div class="context-label">{{ 'Ende' | translate }}</div>
                <div class="context-value">
                  <dx-date-box
                    [(value)]="catalog.agreement.endDate"
                    type="date"
                    displayFormat="dd.MM.yyyy">
                  </dx-date-box>
                </div>
              </div>
            </div>
          </div>
        </dxi-item>

      </dx-tab-panel>
    </div>
  </div>
</dx-popup>
